<div class="tab_page">

    <app-header></app-header>

    <mat-tab-group mat-align-tabs="start">
        <mat-tab label="Organization Hierarchy">
            <app-create-organisation-hierarchy [organisationId]="organisationId"></app-create-organisation-hierarchy>
        </mat-tab>

        <mat-tab label="Users List">
            <app-users [organisationId]="organisationId"></app-users>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon style="width: 27px !important;
    height: 27px !important;
    font-size: 27px !important;">settings</mat-icon>
            </ng-template>
            <app-settings [organisationId]="organisationId"></app-settings>
        </mat-tab>

        <!-- <mat-tab label="User Hierarchy">
        <div class="content">
            <img style="width: -webkit-fill-available;" src="../../../assets/images/user-hierarchy.png" alt="">
        </div>
    </mat-tab> -->
        <!-- <mat-tab label="Stores">
        <app-stores></app-stores>
    </mat-tab> -->

    </mat-tab-group>
</div>